import React from 'react';

import { gradeArr, GRADE_OVER_18, getSchoolYearLabel } from '../../helper';
import './formFieldChrome.css';

const HINTS = {
    auto: 'Estimated from date of birth. Open the dropdown to change it.',
    manual: 'Set manually. Changing the date of birth will re-estimate it.',
    over18: "Grade isn't applicable for participants over 18.",
};

/**
 * Grade dropdown with the auto-derived-from-DOB affordances.
 *
 * Works in two modes because the profile forms differ: pass `value` + `onChange` for a
 * controlled select (editCamper), or `name` + `inputRef` to let react-hook-form's
 * register/setValue drive the DOM node (Camperform). Passing `value` in the react-hook-form
 * case would fight setValue.
 *
 * Over 18: the select is locked rather than rewritten to a one-item list, because the
 * sentinel is already the last gradeArr entry and setValue would race a shrinking list.
 */
const GradeSelect = props => {
    const { value, onChange, name, inputRef, isAuto, isOver18, error, disabled } = props;

    const over18 = isOver18 === undefined ? value === GRADE_OVER_18 : isOver18;
    const isControlled = value !== undefined;

    const hint = over18 ? HINTS.over18 : (isAuto ? HINTS.auto : HINTS.manual);

    return (
        <>
            <label>Current grade (school year {getSchoolYearLabel()})</label>

            {/* Same reserved row as DateSelector's Day/Month/Year captions — keeps the two
                fields' controls on one line whether or not the badge is showing. */}
            <span className="fieldSubLabel">
                {isAuto && !over18 ? <span className="gradeAutoBadge">Auto</span> : ''}
            </span>

            <select
                name={name}
                ref={inputRef}
                disabled={disabled || over18}
                className={`form-control ${error ? 'is-invalid' : ''}`}
                onChange={e => onChange(e.target.value)}
                {...(isControlled ? { value: value || '' } : {})}>
                <option value="">Select Grade</option>
                {gradeArr.map(item => <option key={item} value={item}>{item}</option>)}
            </select>

            <p className="gradeHint">{hint}</p>
        </>
    );
};

export default GradeSelect;
